import { auth } from '../../firebase';

const parseApiJson = async (response) => {
  const text = await response.text();
  try { return text ? JSON.parse(text) : {}; }
  catch {
    const looksLikeHtml = /^\s*</.test(text || '');
    return {
      error: looksLikeHtml
        ? 'El servicio de importación no respondió correctamente. Verifica el despliegue e inténtalo de nuevo.'
        : (text || 'Respuesta inválida del servidor'),
    };
  }
};

export async function commitProductTransferImport({ file, decisions, selectorDecisions }) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('No se pudo validar tu sesión. Vuelve a iniciar sesión.');

  const response = await fetch('/api/products/import-transfer', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ file, decisions, selectorDecisions }),
  });
  const data = await parseApiJson(response);
  if (!response.ok) {
    const error = new Error(data?.error || 'No se pudo completar la importación.');
    error.code = data?.code || 'IMPORT_FAILED';
    error.details = Array.isArray(data?.details) ? data.details : [];
    throw error;
  }
  return data;
}
